module.exports = __webpack_public_path__ + "df3692c629ff9b83c72bff523148d12a.jpg";